/* Accessibility safety nets for content we cannot fix in the theme repo
   (Replo-generated pages are overwritten on republish; proper fixes belong
   in the Replo editor):
   1. Images without an alt attribute are announced by screen readers using
      their file name. Mark them decorative (alt="") until proper alt text
      is authored.
   2. Pages without any <h1> (the Replo product templates) get a
      visually-hidden <h1> from the page's og:title so the document has a
      top-level heading. Self-disables once a real <h1> is published. */
(function () {
  function patchMissingAlt() {
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }
  function patchMissingH1() {
    if (document.querySelector('h1')) return;
    var meta = document.querySelector('meta[property="og:title"]');
    var title = (meta && meta.getAttribute('content')) || document.title;
    if (!title) return;
    var h1 = document.createElement('h1');
    h1.className = 'visually-hidden';
    h1.textContent = title;
    var main = document.getElementById('MainContent') || document.body;
    main.insertBefore(h1, main.firstChild);
  }
  function apply() {
    patchMissingAlt();
    patchMissingH1();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
